import ProfileGrid from './ProfileGrid';

export default ProfileGrid;
